import { useEffect } from "react";

export function useOnce(cb: React.EffectCallback) {
  // Intentionally ignore the dependencies because we only want to call once
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(cb, []);
}
